import React from 'react';
import { GREEN_TICK, WHATSAPP_NUMBER } from '../constant/constant';
import { Link } from 'react-router-dom';

const Plan = () => {
    return (
        <>
            <div className="bg plan-bg">
                <h1>Plans</h1>
            </div>
            <div className='clear-both'></div>
            <section className="pb-24 sm:py-12 px-4 sm:px-10 lg:px-16 sm:pt-12 pt-8">
                <div className="max-w-screen-2xl mx-auto">
                    <div className="text-justify">
                        <section className="bg-white">
                            <div className="pb-8 px-4 mx-auto max-w-screen-xl lg:pb-16 lg:px-6">
                                <div className="mx-auto max-w-screen-full text-center mb-8 lg:mb-12">
                                    <h2 className="mb-4 text-4xl tracking-tight font-extrabold dark:text-black">Designed for business teams like yours</h2>
                                    <p className="mb-5 font-light  sm:text-xl ">Here at Adski we focus on markets where innovation and capital can unlock long-term value and drive economic growth.</p>
                                </div>
                                <div className="space-y-8 lg:grid lg:grid-cols-3 sm:gap-6 xl:gap-10 lg:space-y-0">
                                    <div className="flex flex-col p-6 mx-auto max-w-lg text-center bg-white rounded-3xl border border-gray-600 shadow-slate-300 shadow-xl dark:border-gray-600 xl:p-8 text-black">
                                        <h3 className="mb-4 text-2xl font-semibold">Basic</h3>
                                        <p className="font-light sm:text-lg ">Best option for Perfect for small businesses starting with Meta Ads.</p>
                                        <div className="flex justify-center items-baseline my-8">
                                            <span className="mr-2 font-extrabold md:text-4xl lg:text-5xl sm:text-3xl">₹ 15,000</span>
                                            <span >/3 month</span>
                                        </div>
                                    
                                        <ul className="mb-8 space-y-4 text-left h-full">
                                            <li className="flex items-center space-x-3">
                                                {GREEN_TICK}
                                                <span>8 Graphics / month</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>3 Reels / month</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>3 Ad Management (Facebook & Instagram)</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>WhatsApp Ads</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>3 Ad Creatives Design</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>Lead Form Ads</span>
                                            </li>
                                        </ul>
                                        <Link to={`https://wa.me/${WHATSAPP_NUMBER}`} target='_blank' className="text-white bg-black focus:ring-font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white">Purchase Plan</Link>
                                    </div>

                                    <div className="flex flex-col p-6 mx-auto max-w-lg text-center text-white bg-black rounded-3xl border border-gray-600 shadow dark:border-gray-600 xl:p-8 dark:text-black">
                                        <h3 className="mb-4 text-2xl font-semibold relative flex items-center justify-center dark:text-white">Standard
                                         <span className="h-6 px-3 relative rounded-full border border-solid border-gray-100 text-sm ml-4">Popular</span>
                                            </h3>
                                        <p className="font-light text-white sm:text-lg dark:text-white">Relevant for businesses ready to scale with better conversions.</p>
                                        <div className="flex justify-center items-baseline my-8 text-white">
                                            <span className="mr-2 md:text-4xl lg:text-5xl sm:text-3xl font-extrabold">₹ 22,000</span>
                                            <span>/3 month</span>
                                        </div>
                                        <ul className="mb-8 space-y-4 text-left text-white h-full">
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>10 Graphics / month</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>5 Reels / month</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>5 Ad Management (Facebook & Instagram)</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>WhatsApp Ads</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>Lead Form Ads</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>5 Ad Creatives Design</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>Landing Page Creation (1 Page)</span>
                                            </li>
                                        </ul>
                                        <Link to={`https://wa.me/${WHATSAPP_NUMBER}`} target='_blank' className="text-black bg-white hover:bg-white-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-black">Purchase Plan</Link>
                                    </div>

                                    <div className="flex flex-col p-6 mx-auto max-w-lg text-center  bg-white rounded-3xl border border-gray-600 shadow-slate-300 shadow-xl dark:border-gray-600 xl:p-8 text-black">
                                        <h3 className="mb-4 text-2xl font-semibold">Premium</h3>
                                        <p className="font-light  sm:text-lg ">Best for brands wanting a complete digital performance setup.</p>
                                        <div className="flex justify-center items-baseline my-8">
                                            <span className="mr-2 md:text-4xl lg:text-5xl sm:text-3xl font-extrabold">₹ 30,000</span>
                                            <span >/3 month</span>
                                        </div>
                                        <ul className="mb-8 space-y-4 text-left h-full">
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>12 Graphics / month</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>6 Reels / month</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>Ad Management (Facebook & Instagram) [Unlimitied]</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>WhatsApp Ads</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>Lead Form Ads</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>Ad Creatives Design [Unlimitied]</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>Landing Page Creation (1 Page)</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>Google My Business (GMB) Profile Management</span>
                                            </li>
                                            <li className="flex items-center space-x-3">
                                                 {GREEN_TICK}
                                                <span>Social Profile Management (Facebook, Instagram & LinkedIn)</span>
                                            </li>
                                        </ul>
                                        <Link to={`https://wa.me/${WHATSAPP_NUMBER}`} target='_blank' className="text-white bg-black focus:ring-font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-white">Purchase Plan</Link>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Plan;
